/*
 * Modules dependencies
 */

import { Button } from 'src/components/core/buttons/button';
import { CallMeModal } from 'src/components/call-me-modal';
import { Image } from 'src/components/core/image';
import { Text } from 'src/components/core/text';
import { breakpoints } from '@untile/react-core/styles/breakpoints';
import { media } from '@untile/react-core/styles/media';
import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import phoneIcon from 'src/assets/svgs/phone.svg';
import styled from 'styled-components';

/**
 * `Grid` styled component.
 */

const Grid = styled.div`
  background: var(--gradient-secondary--45-deg);
  border-radius: var(--border-radius-sm);
  display: grid;
  grid-template-areas: 'image' 'content';
  grid-template-rows: 248px auto;
  height: 100%;

  ${media.min.xs`
    grid-template-rows: 400px auto;
  `}

  ${media.min.ms`
    grid-template-areas: 'image content';
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 320px;
  `}

  ${media.min.xl`
    grid-template-rows: 448px;
  `}
`;

/*
 * `ImageWrapper` styled component.
 */

const ImageWrapper = styled.div`
  border-radius: var(--border-radius-sm);
  grid-area: image;
  overflow: hidden;
  position: relative;
`;

/*
 * `Content` styled component.
 */

const Content = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: content;
  max-width: 524px;
  padding: var(--space-ms) calc(var(--space-sm) * 3) var(--space-sm) var(--space-sm);
`;

/**
 * `Name` styled component.
 */

const Name = styled(Text).attrs({ variant: 'labelM', weight: 600 })`
  background: var(--gradient-primary--0-deg);
  -webkit-background-clip: text;
  background-clip: text;
  color: var(--color-primary);
  -webkit-text-fill-color: transparent;
  margin-bottom: var(--space-xxs);
`;

/**
 * Export `CardMovelUnit` component.
 */

export function CardMovelUnit() {
  const { t } = useTranslation('common');
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <Grid>
      <ImageWrapper>
        <Image
          alt={t('contacts.movelUnit.image.alt')}
          fill
          sizes={`(max-width: ${breakpoints.ms}px) 100vw, (max-width: ${breakpoints.lg}px) 75vw, 50vw`}
          src={t('contacts.movelUnit.image.src')}
          style={{ objectFit: 'cover' }}
        />
      </ImageWrapper>

      <Content>
        <Name>{t('contacts.movelUnit.nameServicePage')}</Name>

        <Text as={'p'} style={{ marginBottom: 'var(--space-xs)' }} variant={'h3'} weight={600}>
          {t('contacts.movelUnit.title')}
        </Text>

        <Text as={'p'} style={{ marginBottom: 'var(--space-ms)' }} variant={'bodyL'}>
          {t('contacts.movelUnit.description')}
        </Text>

        <Button
          aria-label={t('actions.callMe')}
          colorTheme={'outlineDarkened'}
          icon={phoneIcon}
          onClick={() => setIsModalOpen(true)}
          reverse
          size={'medium'}
          style={{ marginTop: 'auto', width: 'fit-content' }}
        >
          {t('actions.callMe')}
        </Button>

        <CallMeModal isOpen={isModalOpen} onRequesClose={() => setIsModalOpen(false)} />
      </Content>
    </Grid>
  );
}
